import React, { useCallback } from 'react';
import dayjs from 'dayjs';
import Link from 'next/link';

interface ICardAProps {
  name: string;
  logo: string;
  state: string;
  isFreeMint: number;
  startTime: number;
  vanityUrl: string;
  mintPrice: number;
  supply: number;
  available: number;
}

const CardA: React.FC<ICardAProps> = ({
  name,
  logo,
  isFreeMint,
  state,
  startTime,
  vanityUrl,
  mintPrice,
  supply,
  available,
}) => {
  const statusRender = useCallback(() => {
    if (state === 'NOT_START') {
      return (
        <div className="w-full text-sm font-normal text-neutral-400">
          Starts at {dayjs(startTime).local().format('MMMM D, YYYY HH:mm')}
        </div>
      );
    } else if (state === 'IN_PROGRESS') {
      return (
        <div className="flex w-full flex-wrap items-center justify-between gap-2 text-sm font-normal">
          {isFreeMint === 1 ? (
            <div className="launchBg">FREE MINT</div>
          ) : (
            <div className="text-app ">{mintPrice} BTC</div>
          )}
          <div className="text-neutral-400 ">
            Available {available}/{supply}
          </div>
        </div>
      );
    } else if (state === 'SOLD_OUT') {
      return (
        <div className="w-full text-sm font-normal text-neutral-400">
          SOLD OUT
        </div>
      );
    } else if (state === 'ENDED') {
      return (
        <div className="w-full text-sm font-normal text-neutral-400">ENDED</div>
      );
    }
  }, [available, isFreeMint, mintPrice, startTime, state, supply]);

  return (
    <Link href={`/l/${vanityUrl}`} className="rounded-2xl bg-neutral-900">
      <div className="group text-white">
        <div className="h-[240px] overflow-hidden rounded-t-2xl bg-cover bg-no-repeat">
          <img
            src={logo}
            className="pointer-events-none h-full w-full rounded-t-2xl object-cover duration-500 group-hover:scale-110"
            alt=""
            onError={(e: any) => {
              e.target.src =
                'https://s.luckygo.io/luckybuy/img/detailAvatarImg.png';
            }}
          />
        </div>
        <div className="p-5">
          <div className="truncate text-xl font-medium">{name}</div>
          <div className="mt-3 flex text-center">{statusRender()}</div>
        </div>
      </div>
    </Link>
  );
};

export default CardA;
